export const FORUM_POST_MENU_MORE = (id: number) => `forum-post-menu-more-${id}`;
export const FORUM_COMMENT_MENU_MORE = (id: number) => `forum-comment-menu-more-${id}`;
